import { TableCell, styled } from '@mui/material';

export const StyledTableCell = styled(TableCell)`
  border: 0;
`;